export default __webpack_public_path__ + "static/txn-process-preauthorized-c8b7b932ee0930ef9c7c571bf84c7aa3.png";